import React from 'react';

import { ButtonObject, GMetrixButtonGroup } from 'components/GMetrixButtonGroup/GMetrixButtonGroup';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'react-bootstrap';

interface ViewOptionsBarProps {
    buttonGroups: ButtonObject[][];
    children?: React.ReactNode;
}

export const ViewOptionsBar: React.FC<ViewOptionsBarProps> = ({
    buttonGroups,
    children
}) => (
    <div className="d-flex">
        <div>
            <small className="mb-2 d-block fw-bold">
                <FormattedMessage defaultMessage="View Options" id="view_options.d577ac1b" />
            </small>
            <Row className="g-3">
                {buttonGroups.map((group, index) => (
                    <Col key={`GMX_BTNGRP_${index}`} xs="auto">
                        <GMetrixButtonGroup buttonObjectList={group} />
                    </Col>
                ))}
            </Row>
        </div>
        {children}
    </div>
);
